import { Coin } from '@starsoft/common/models';
import { useResolvedSettings } from '../useResolvedSettings';

export function useSystemCoin(): Coin {
  const { systemCoin } = useResolvedSettings();

  return systemCoin;
}
